// KEEP IN SYNC with the backend normalizer in
// cnc-worker-backend/src/features/postMailing/helpers/designKind.js (pdfSheets / MAX_PDF_SHEETS).

export const MAX_PDF_SHEETS = 9;

/**
 * Normalize a PDF-kind designData's sheets to an array, regardless of storage shape: new templates
 * carry `pdf.sheets[]`, legacy single-sheet templates carry flat `pdf.frontAssetId`/`backAssetId`
 * (mapped to a one-element array here). Returns [] for non-PDF designs and PDF designs with no
 * uploads yet.
 * @param {object} [designData]
 * @returns {Array<{ frontAssetId: string|null, backAssetId: string|null, frontMeta: object|null, backMeta: object|null }>}
 */
export function pdfSheets(designData) {
	if (designData?.kind !== 'pdf') return [];
	const pdf = designData.pdf ?? {};
	if (Array.isArray(pdf.sheets) && pdf.sheets.length > 0) return pdf.sheets;
	if (pdf.frontAssetId || pdf.backAssetId) {
		return [
			{
				frontAssetId: pdf.frontAssetId ?? null,
				backAssetId: pdf.backAssetId ?? null,
				frontMeta: pdf.frontMeta ?? null,
				backMeta: pdf.backMeta ?? null,
			},
		];
	}
	return [];
}
